
import BtcPage from "./pages/Btc";

BtcPage.path = '/monitor/:doorId';

export default {
  pages: {
    BtcPage
  }
};
